/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { IntegrationEventsPaginatedResponse } from '../../models/integration-events-paginated-response';

export interface IntegrationEventsControllerFindAll$Params {

/**
 * Entity type to filter events (e.g., TICKET, ORDER, DELIVERY)
 */
  entityType: 'TICKET' | 'ORDER' | 'DELIVERY';

/**
 * UUID of the last consumed event. Returns events that occurred after this event.
 */
  afterId?: string;

/**
 * Maximum number of events to return. Default: 100, Max: 1000
 */
  limit?: number;
}

export function integrationEventsControllerFindAll(http: HttpClient, rootUrl: string, params: IntegrationEventsControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<IntegrationEventsPaginatedResponse>> {
  const rb = new RequestBuilder(rootUrl, integrationEventsControllerFindAll.PATH, 'get');
  if (params) {
    rb.query('entityType', params.entityType, {});
    rb.query('afterId', params.afterId, {});
    rb.query('limit', params.limit, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<IntegrationEventsPaginatedResponse>;
    })
  );
}

integrationEventsControllerFindAll.PATH = '/integration-events';
